/* import __COLOCATED_TEMPLATE__ from './categories.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';
import type AppService from 'embercom/services/app-service';
import { registerDestructor } from '@ember/destroyable';
import { action } from '@ember/object';

export default class Categories extends Component {
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;
  @service declare appService: AppService;
  @tracked showPreview = true;

  get shouldShowEmberPreview() {
    return this.showPreview && !this.appService.app.canUseFeature('react-preview-panel-attributes');
  }

  constructor(owner: unknown, args: {}) {
    super(owner, args);
    let unsubscribe = this.reactTeammateAppIsland.subscribeToTeammateAppEvent(
      'categories:preview:open',
      () => {
        this.showPreview = true;
      },
    );

    registerDestructor(this, unsubscribe);
  }

  @action closePreview() {
    this.showPreview = false;
    this.reactTeammateAppIsland.dispatchTeammateAppEvent('categories:preview:close');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Categories': typeof Categories;
    'ai-agent/categories': typeof Categories;
  }
}
